module.exports = __webpack_public_path__ + "img/hotel.d4e83506.svg";